export const translations = {
  fr: {
    nav: {
      about: "Manifeste",
      services: "Missions",
      projects: "Réalisations",
      testimonials: "Avis",
      simulator: "Simulateur",
      appointment: "Rendez-vous",
      contact: "Contact",
      blog: "Journal",
      cta: "Démarrer un projet",
      callNow: "Appeler",
    },
    projectDetail: {
      back: "Retour aux réalisations",
      surface: "Surface",
      duration: "Durée",
      year: "Année",
      client: "Client",
      category: "Catégorie",
      location: "Lieu",
      before: "Avant",
      after: "Après",
      overview: "Aperçu",
      description: "Description",
      gallery: "Galerie",
      photos: "photos du chantier",
      scroll: "Faites défiler",
      cta: "Discuter d'un projet similaire",
    },
    blog: {
      label: "Journal",
      title: "Carnets de",
      titleItalic: "chantier",
      intro: "Réflexions, méthodes et retours d'expérience issus de nos projets en Charente-Maritime.",
      readMore: "Lire l'article",
      readMin: "min de lecture",
      back: "Retour au journal",
    },
    hero: {
      tag: "Maîtrise d'œuvre — Rochefort (17)",
      title1: "Les bâtiments",
      title2: "ont une",
      title3: "âme.",
      italic: "Nous la révélons.",
      intro:
        "Cabinet ECHO pilote vos projets de construction, rénovation et extension en Charente-Maritime. Nous coordonnons les artisans, respectons les délais et protégeons votre budget — pour que votre projet devienne un lieu habité.",
      primaryCta: "Prendre rendez-vous",
      secondaryCta: "Voir les réalisations",
      simulatorCta: "Simuler le coût de mes travaux",
      reviewsOn: "avis Google",
      reviewsLabel: "Avis clients",
      scroll: "Défiler",
      trustStats: [
        { value: "4,2", unit: "/5", label: "★★★★★ 10 avis clients" },
        { value: "~100", unit: "", label: "Projets pilotés — missions totales ou partielles" },
        { value: "2016", unit: "", label: "année de création" },
        { value: "4", unit: "villes", label: "Rochefort · La Rochelle · Saintes · Royan" },
      ],
    },
    marquee: [
      "Rochefort",
      "La Rochelle",
      "Saintes",
      "Royan",
      "Construction neuve",
      "Rénovation",
      "Extension",
      "Patrimoine",
      "Écologie",
      "Coordination artisans",
      "Respect du budget",
      "Maîtrise des délais",
    ],
    about: {
      label: "Manifeste",
      title: "Qu'est-ce qu'un",
      titleItalic: "maître d'œuvre",
      titleEnd: "?",
      lead:
        "Le maître d'œuvre est le chef d'orchestre de votre chantier. Il conçoit, coordonne et contrôle — garantissant qualité, délais et budget.",
      pillars: [
        {
          n: "01",
          t: "Étude",
          d: "Analyse des besoins, propositions adaptées, esquisse et plans techniques.",
        },
        {
          n: "02",
          t: "Planification",
          d: "Calendrier précis, budget détaillé, sélection des artisans et corps de métier.",
        },
        {
          n: "03",
          t: "Coordination",
          d: "Pilotage quotidien du chantier, communication entre intervenants, suivi terrain.",
        },
        {
          n: "04",
          t: "Livraison",
          d: "Contrôle de conformité, levée des réserves, remise des clés en toute sérénité.",
        },
      ],
    },
    services: {
      label: "Missions",
      title: "Un accompagnement",
      titleItalic: "complet",
      titleEnd: ", de l'esquisse à la remise des clés.",
      items: [
        {
          t: "Construction neuve",
          d: "De l'étude de faisabilité au permis de construire, nous concevons des habitats responsables, durables, conformes aux dernières normes énergétiques.",
          tags: ["RE2020", "Plans", "Permis"],
        },
        {
          t: "Rénovation",
          d: "Rénovation lourde ou légère, nous révélons le potentiel du bâti ancien en respectant son âme et en modernisant ses usages.",
          tags: ["Patrimoine", "Matériaux", "Confort"],
        },
        {
          t: "Extension & Surélévation",
          d: "Agrandir sans dénaturer. Nous concevons des extensions qui dialoguent avec l'existant et augmentent la valeur du bien.",
          tags: ["Structure", "Volumes", "Continuité"],
        },
        {
          t: "Étude de faisabilité",
          d: "Mission plus approfondie que la visite conseil, engagée lorsqu'un projet est envisagé sérieusement. Elle analyse la faisabilité technique, réglementaire et financière d'une opération : consultation du PLU ou du PSMV, vérification des contraintes de prospect et de hauteur, analyse du bâti existant, esquisse de programme, estimation budgétaire détaillée. L'étude de faisabilité est le préalable indispensable à toute décision d'engager une maîtrise d'œuvre complète — elle transforme une intention en projet éclairé.",
          tags: ["PLU/PSMV", "Programme", "Chiffrage"],
        },
        {
          t: "Visite conseil",
          d: "Avant achat ou avant travaux, un regard professionnel sur le potentiel, les contraintes techniques et l'enveloppe budgétaire.",
          tags: ["Audit", "Faisabilité", "Budget"],
        },
      ],
    },
    projects: {
      label: "Réalisations",
      title: "Une centaine de projets,",
      titleItalic: "une même exigence.",
      cta: "Discuter de mon projet",
      items: [
        { slug: "cci-rochefort", y: "2019", cat: "Tertiaire", t: "CCI Rochefort & Saintonge", l: "Rochefort", d: "Transformation de bureaux en salles de cours — 380 m²." },
        { slug: "projet-republique", y: "2020", cat: "Rénovation", t: "Projet République", l: "Rochefort", d: "Rénovation complète d'une maison de ville ancienne." },
        { slug: "maison-faubourg-rochefort", y: "2022", cat: "Rénovation", t: "Rénovation complète d'une maison de faubourg", l: "Rochefort", d: "Rénovation intégrale d'une maison de faubourg rochefortais." },
        { slug: "cave-des-demoiselles", y: "2021", cat: "Commerce", t: "La Cave des Demoiselles", l: "Rochefort", d: "Création d'une cave à vins, devanture & aménagement intérieur." },
        { slug: "grange-marsais", y: "2022", cat: "Rénovation", t: "Grange de Marsais", l: "Marsais", d: "Transformation d'une grange en habitation principale." },
        { slug: "maison-rochefort", y: "2023", cat: "Extension", t: "Maison Rochefort", l: "Rochefort", d: "Rénovation complète avec extension contemporaine." },
        { slug: "ecomiam-saintes", y: "2023", cat: "Commerce", t: "Magasin Ecomiam", l: "Saintes", d: "Réaménagement d'un local commercial, création d'un magasin." },
        { slug: "villa-la-rochelle", y: "2024", cat: "Haut de gamme", t: "Villa La Rochelle", l: "La Rochelle", d: "Rénovation haut de gamme d'une maison de maître." },
        { slug: "saint-georges-didonne-extension", y: "2026", cat: "Extension", t: "Maison Saint-Georges-de-Didonne", l: "Saint-Georges-de-Didonne", d: "Extension et rénovation contemporaine d'une maison balnéaire des années 70." },
      ],
    },
    simulator: {
      label: "Simulateur",
      title: "Estimez le coût",
      titleItalic: "de vos travaux",
      titleEnd: " en 30 secondes.",
      intro: "Une fourchette indicative, calculée sur les prix du marché en Charente-Maritime.",
      surface: "Surface",
      projectType: "Type de projet",
      finish: "Niveau de prestation",
      finishes: {
        standard: "Standard",
        premium: "Premium",
        haut_de_gamme: "Haut de gamme",
      },
      types: {
        construction: "Construction neuve",
        renovation_legere: "Rénovation légère",
        renovation_complete: "Rénovation complète",
        extension: "Extension",
      },
      estimate: "Estimation",
      from: "de",
      to: "à",
      cta: "Révéler mon estimation",
      ctaAgain: "Recalculer avec d'autres paramètres",
      locked: "VERROUILLÉ",
      lockedIntro: "Laissez vos coordonnées pour débloquer votre estimation personnalisée — elle s'affichera ici et vous la recevrez aussi par email.",
      note: "Estimation indicative hors honoraires de maîtrise d'œuvre.",
      lead: {
        title: "Recevoir l'estimation",
        titleItalic: "par email",
        intro: "Laissez-nous vos coordonnées et nous vous envoyons immédiatement votre estimation personnalisée, accompagnée de conseils adaptés à votre projet.",
        name: "Nom & prénom",
        email: "Email",
        phone: "Téléphone",
        submit: "Recevoir mon estimation",
        success: "C'est envoyé ! Vérifiez votre boîte mail dans quelques instants.",
        error: "Une erreur est survenue. Merci de réessayer.",
        rateLimit: "Trop d'essais sur cette adresse — patientez 1 minute puis réessayez.",
        close: "Fermer",
      },
    },
    appointment: {
      label: "Rendez-vous",
      title: "Prendre un",
      titleItalic: "rendez-vous",
      titleEnd: " avec le Cabinet.",
      intro: "Une visite conseil personnalisée pour clarifier votre projet, évaluer la faisabilité et vous guider vers les bonnes décisions.",
      tabLabel: "Prendre rendez-vous",
      name: "Nom & prénom",
      email: "Email",
      phone: "Téléphone",
      date: "Date souhaitée",
      time: "Créneau",
      project: "Type de projet",
      location: "Lieu du projet",
      notes: "Détails du projet",
      submit: "Réserver mon créneau",
      success: "Demande enregistrée. Nous revenons vers vous sous 24 h.",
      error: "Une erreur est survenue. Merci de réessayer.",
      projects: {
        construction: "Construction neuve",
        renovation: "Rénovation",
        extension: "Extension",
        conseil: "Visite conseil",
      },
    },
    testimonials: {
      label: "Paroles de clients",
      title: "Ce qu'ils en",
      titleItalic: "disent",
      titleEnd: ".",
      intro: "Les avis de nos clients — recueillis et publiés sur notre fiche Google.",
      source: "Via Google",
      visited: "Visité en",
    },
    contact: {
      label: "Contact",
      title: "Parlons de",
      titleItalic: "votre projet",
      titleEnd: ".",
      intro: "Une question, un devis, un échange rapide ? Écrivez-nous.",
      tabLabel: "Message rapide",
      name: "Nom",
      email: "Email",
      phone: "Téléphone",
      subject: "Sujet",
      message: "Votre message",
      submit: "Envoyer le message",
      success: "Message envoyé. Merci — nous revenons vers vous rapidement.",
      error: "Une erreur est survenue. Merci de réessayer.",
      openInMaps: "Ouvrir dans Google Maps",
    },
    footer: {
      tag: "Maîtrise d'œuvre",
      address: "69 rue des pêcheurs d'Islande, 17300 Rochefort",
      rights: "Tous droits réservés",
      craft: "Site refondu avec soin",
      team: "L'équipe",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      navTitle: "Navigation",
      contactTitle: "Contact",
      followTitle: "Suivez",
      method: "Méthode",
      glossary: "Lexique",
      zonesTitle: "Zones d'intervention",
      networksTitle: "Professionnel référencé par",
      zoneLaRochelle: "La Rochelle",
      zoneRochefort: "Rochefort",
      zoneSaintes: "Saintes",
      zoneRoyan: "Royan",
    },
    faq: {
      label: "Questions fréquentes",
      title: "Tout ce qu'on vous explique",
      titleItalic: "avant de signer.",
      intro: "Ce qu'on entend le plus souvent en visite conseil, mis ici pour gagner du temps. Si votre question n'y est pas, écrivez-nous — c'est rapide.",
      items: [
        { q: "Qu'est-ce qu'un maître d'œuvre, concrètement ?", a: "Le maître d'œuvre est le chef d'orchestre de votre chantier. Il conçoit les plans, sélectionne et coordonne les artisans, pilote le calendrier et contrôle la qualité — garantissant que le projet respecte le budget et les délais, de l'étude à la remise des clés." },
        { q: "Quelle est la différence avec un architecte ?", a: "L'architecte est obligatoire pour les constructions dépassant 150 m² de surface plancher. Le maître d'œuvre, lui, intervient sans limite de surface, pilote l'exécution et la coordination. Les deux peuvent concevoir, mais le maître d'œuvre reste présent jusqu'à la livraison du chantier." },
        { q: "Combien coûte un maître d'œuvre ?", a: "Les honoraires d'une mission complète se situent entre 8 % et 12 % du montant HT des travaux, selon la complexité et le niveau d'accompagnement. Le devis est clair et transparent avant signature, sans coût caché." },
        { q: "Où intervient le Cabinet ECHO ?", a: "Toute la Charente-Maritime : Rochefort (siège), La Rochelle, Saintes, Royan, Marsais, Pons, Saint-Jean-d'Angély, Cognac, Tonnay-Charente. La Saintonge est notre territoire quotidien." },
        { q: "Comment obtenir une estimation pour mes travaux ?", a: "Le simulateur en ligne donne une fourchette indicative en 30 secondes. Pour un chiffrage précis, prenez rendez-vous : la visite conseil sur site (1h30) est la première étape — nous lisons le bâti ou le terrain avec vous avant de proposer un scénario." },
        { q: "Travaillez-vous sur le patrimoine ancien ?", a: "C'est l'une de nos spécialités. Pierre de Saintonge, contraintes ABF (Architecte des Bâtiments de France), Sites Patrimoniaux Remarquables de Rochefort et Saintes, isolations respectueuses du bâti (chaux-chanvre, fibre de bois) — ces sujets font partie de notre quotidien depuis 2016." },
        { q: "Combien de temps prend un chantier type ?", a: "Rénovation légère 100 m² : 3 à 5 mois. Rénovation lourde 130 m² : 12 à 22 mois. Extension 30 m² : 4 à 6 mois. Construction neuve 150 m² : 12 à 15 mois. Villa haut de gamme 250+ m² : 16 à 22 mois. Ces durées incluent études et chantier." },
      ],
    },
    team: {
      label: "L'équipe",
      heading: "Deux regards, un même engagement.",
      intro:
        "Le Cabinet ECHO, c'est avant tout une rencontre entre deux professionnels passionnés de maîtrise d'œuvre. Nicolas conduit les chantiers, Mathilde conçoit les projets — ensemble, ils vous accompagnent de la première visite jusqu'à la remise des clés.",
      meetLabel: "Nous rencontrer",
      meetTitle1: "Échangeons sur",
      meetTitle2: "votre projet",
      meetCta: "Prendre rendez-vous",
    },
  },
  en: {
    nav: {
      about: "Manifesto",
      services: "Missions",
      projects: "Projects",
      testimonials: "Reviews",
      simulator: "Simulator",
      appointment: "Book a visit",
      contact: "Contact",
      blog: "Journal",
      cta: "Start a project",
      callNow: "Call",
    },
    projectDetail: {
      back: "Back to projects",
      surface: "Area",
      duration: "Duration",
      year: "Year",
      client: "Client",
      category: "Category",
      location: "Location",
      before: "Before",
      after: "After",
      overview: "Overview",
      description: "Description",
      gallery: "Gallery",
      photos: "site photos",
      scroll: "Scroll",
      cta: "Discuss a similar project",
    },
    blog: {
      label: "Journal",
      title: "Site",
      titleItalic: "notebooks",
      intro: "Reflections, methods and field notes from our Charente-Maritime projects.",
      readMore: "Read the article",
      readMin: "min read",
      back: "Back to journal",
    },
    hero: {
      tag: "Project Management — Rochefort, France",
      title1: "Old buildings",
      title2: "have a",
      title3: "soul.",
      italic: "We reveal it.",
      intro:
        "Cabinet ECHO leads your construction, renovation and extension projects in Charente-Maritime. We coordinate craftsmen, protect deadlines and your budget — so your project becomes a home worth living in.",
      primaryCta: "Book a visit",
      secondaryCta: "See our work",
      simulatorCta: "Estimate my project cost",
      reviewsOn: "Google reviews",
      reviewsLabel: "Client reviews",
      scroll: "Scroll",
      trustStats: [
        { value: "4.2", unit: "/5", label: "★★★★★ 10 client reviews" },
        { value: "~100", unit: "", label: "Projects managed — full or partial missions" },
        { value: "2016", unit: "", label: "founded in" },
        { value: "4", unit: "cities", label: "Rochefort · La Rochelle · Saintes · Royan" },
      ],
    },
    marquee: [
      "Rochefort",
      "La Rochelle",
      "Saintes",
      "Royan",
      "New construction",
      "Renovation",
      "Extension",
      "Heritage",
      "Ecology",
      "Craftsmen coordination",
      "Budget discipline",
      "On-time delivery",
    ],
    about: {
      label: "Manifesto",
      title: "What is a",
      titleItalic: "project manager",
      titleEnd: "?",
      lead:
        "The maître d'œuvre conducts your building site. We design, coordinate and control — guaranteeing quality, deadlines and budget.",
      pillars: [
        { n: "01", t: "Study", d: "Needs analysis, tailored proposals, sketches and technical plans." },
        { n: "02", t: "Planning", d: "Precise schedule, detailed budget, selection of trades and craftsmen." },
        { n: "03", t: "Coordination", d: "Daily site leadership, communication between stakeholders, field follow-up." },
        { n: "04", t: "Delivery", d: "Conformity checks, reserves resolution, keys handed over in confidence." },
      ],
    },
    services: {
      label: "Missions",
      title: "A",
      titleItalic: "complete",
      titleEnd: " accompaniment, from sketch to keys.",
      items: [
        { t: "New Construction", d: "From feasibility to building permit, we design sustainable, energy-compliant homes.", tags: ["RE2020", "Plans", "Permit"] },
        { t: "Renovation", d: "Heavy or light renovation — we reveal the potential of old buildings while respecting their soul.", tags: ["Heritage", "Materials", "Comfort"] },
        { t: "Extension & Raising", d: "Expanding without betraying. Extensions that dialogue with existing structures.", tags: ["Structure", "Volumes", "Continuity"] },
        { t: "Feasibility Study", d: "A deeper mission than the advice visit, undertaken once a project is seriously considered. It examines the technical, regulatory and financial feasibility of an operation: PLU or PSMV review, setback and height constraints, existing-building analysis, programme outline, detailed budget estimate. The feasibility study is the essential prerequisite to any commitment to a full project management mission — it turns an intention into an informed project.", tags: ["PLU/PSMV", "Programme", "Costing"] },
        { t: "Advice Visit", d: "Before buying or building, a professional eye on potential, constraints and budget.", tags: ["Audit", "Feasibility", "Budget"] },
      ],
    },
    projects: {
      label: "Projects",
      title: "A hundred projects,",
      titleItalic: "one standard.",
      cta: "Discuss my project",
      items: [
        { slug: "cci-rochefort", y: "2019", cat: "Workspace", t: "CCI Rochefort & Saintonge", l: "Rochefort", d: "Offices transformed into classrooms — 380 sqm." },
        { slug: "projet-republique", y: "2020", cat: "Renovation", t: "Projet République", l: "Rochefort", d: "Full renovation of a historical townhouse." },
        { slug: "maison-faubourg-rochefort", y: "2022", cat: "Renovation", t: "Full renovation of a faubourg house", l: "Rochefort", d: "Full renovation of a typical Rochefort faubourg house — from as-found to delivery." },
        { slug: "cave-des-demoiselles", y: "2021", cat: "Retail", t: "La Cave des Demoiselles", l: "Rochefort", d: "Wine cellar creation — storefront & interior." },
        { slug: "grange-marsais", y: "2022", cat: "Renovation", t: "Marsais Barn", l: "Marsais", d: "Barn converted into a primary home." },
        { slug: "maison-rochefort", y: "2023", cat: "Extension", t: "House Rochefort", l: "Rochefort", d: "Full renovation with a contemporary extension." },
        { slug: "ecomiam-saintes", y: "2023", cat: "Retail", t: "Ecomiam Store", l: "Saintes", d: "Retail redesign — store creation." },
        { slug: "villa-la-rochelle", y: "2024", cat: "High-end", t: "Villa La Rochelle", l: "La Rochelle", d: "High-end renovation of a master house." },
        { slug: "saint-georges-didonne-extension", y: "2026", cat: "Extension", t: "Saint-Georges-de-Didonne House", l: "Saint-Georges-de-Didonne", d: "Contemporary extension and renovation of a 1970s seaside house." },
      ],
    },
    simulator: {
      label: "Simulator",
      title: "Estimate",
      titleItalic: "your works",
      titleEnd: " in 30 seconds.",
      intro: "An indicative range, based on local market rates.",
      surface: "Surface area",
      projectType: "Project type",
      finish: "Finish level",
      finishes: { standard: "Standard", premium: "Premium", haut_de_gamme: "High-end" },
      types: { construction: "New construction", renovation_legere: "Light renovation", renovation_complete: "Full renovation", extension: "Extension" },
      estimate: "Estimate",
      from: "from",
      to: "to",
      cta: "Reveal my estimate",
      ctaAgain: "Recalculate with other settings",
      locked: "LOCKED",
      lockedIntro: "Share your contact details to unlock your personalised estimate — it will appear here and you'll also receive it by email.",
      note: "Indicative estimate excluding project management fees.",
      lead: {
        title: "Receive the estimate",
        titleItalic: "by email",
        intro: "Leave us your details and we'll send you your personalized estimate right away, with tailored advice for your project.",
        name: "Full name",
        email: "Email",
        phone: "Phone",
        submit: "Send me the estimate",
        success: "Sent! Check your inbox in a moment.",
        error: "Something went wrong. Please try again.",
        rateLimit: "Too many attempts — please wait 1 minute and try again.",
        close: "Close",
      },
    },
    appointment: {
      label: "Book",
      title: "Book a",
      titleItalic: "visit",
      titleEnd: " with the Cabinet.",
      intro: "A personal advice visit to clarify your project, assess feasibility and guide your decisions.",
      tabLabel: "Book a visit",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      date: "Preferred date",
      time: "Time slot",
      project: "Project type",
      location: "Project location",
      notes: "Project details",
      submit: "Book my slot",
      success: "Request saved. We will get back to you within 24h.",
      error: "Something went wrong. Please try again.",
      projects: { construction: "New construction", renovation: "Renovation", extension: "Extension", conseil: "Advice visit" },
    },
    testimonials: {
      label: "Client stories",
      title: "What they",
      titleItalic: "say",
      titleEnd: ".",
      intro: "Reviews from our clients — collected and published on our Google listing.",
      source: "Via Google",
      visited: "Visited in",
    },
    contact: {
      label: "Contact",
      title: "Let's discuss",
      titleItalic: "your project",
      titleEnd: ".",
      intro: "A quick question, a quote, a chat? Drop us a line.",
      tabLabel: "Quick message",
      name: "Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Your message",
      submit: "Send message",
      success: "Message sent. Thank you — we'll get back to you shortly.",
      error: "Something went wrong. Please try again.",
      openInMaps: "Open in Google Maps",
    },
    footer: {
      tag: "Project management",
      address: "69 rue des pêcheurs d'Islande, 17300 Rochefort",
      rights: "All rights reserved",
      craft: "Site rebuilt with care",
      team: "The team",
      legal: "Legal notice",
      privacy: "Privacy policy",
      navTitle: "Navigation",
      contactTitle: "Contact",
      followTitle: "Follow",
      method: "Method",
      glossary: "Glossary",
      zonesTitle: "Where we work",
      networksTitle: "Listed professional with",
      zoneLaRochelle: "La Rochelle",
      zoneRochefort: "Rochefort",
      zoneSaintes: "Saintes",
      zoneRoyan: "Royan",
    },
    faq: {
      label: "Frequently asked",
      title: "Everything we explain",
      titleItalic: "before signing.",
      intro: "What we hear most often during advice visits, gathered here to save time. If your question isn't covered, just write to us — we're quick to reply.",
      items: [
        { q: "What does a project manager actually do?", a: "The project manager is the conductor of your construction site. They design the plans, select and coordinate the craftsmen, drive the schedule and check the quality — making sure the project respects the budget and the deadlines, from study to handover of keys." },
        { q: "What's the difference with an architect?", a: "An architect is legally required for buildings above 150 sqm of floor area. A project manager (maître d'œuvre) can work on any size, leads the execution and coordination. Both can design — but the project manager stays until the keys are handed over." },
        { q: "How much does a project manager cost?", a: "Fees for a full mission usually range between 8% and 12% of the works' net cost, depending on complexity and level of involvement. The quote is clear and transparent before signing, with no hidden costs." },
        { q: "Where does Cabinet ECHO operate?", a: "Across all Charente-Maritime: Rochefort (HQ), La Rochelle, Saintes, Royan, Marsais, Pons, Saint-Jean-d'Angély, Cognac, Tonnay-Charente. Saintonge is our daily territory." },
        { q: "How can I get an estimate for my project?", a: "The online simulator gives an indicative range in 30 seconds. For a precise quote, book an advice visit: the on-site visit (1h30) is the first step — we read the building or the plot with you before proposing a scenario." },
        { q: "Do you work on heritage buildings?", a: "It's one of our specialities. Saintonge limestone, ABF constraints (French heritage architects), Rochefort and Saintes Remarkable Heritage Sites, breathable insulation (lime-hemp, wood fibre) — these are part of our daily practice since 2016." },
        { q: "How long does a typical project take?", a: "Light renovation 100 sqm: 3 to 5 months. Heavy renovation 130 sqm: 12 to 22 months. Extension 30 sqm: 4 to 6 months. New build 150 sqm: 12 to 15 months. High-end villa 250+ sqm: 16 to 22 months. These durations include study and works." },
      ],
    },
    team: {
      label: "The team",
      heading: "Two perspectives, one commitment.",
      intro:
        "Cabinet ECHO is first and foremost the meeting of two professionals passionate about project management. Nicolas leads the sites, Mathilde designs the projects — together, they guide you from the first visit to the handover of keys.",
      meetLabel: "Meet us",
      meetTitle1: "Let's discuss",
      meetTitle2: "your project",
      meetCta: "Book a visit",
    },
  },
};

export const PROJECT_SLUGS = [
  "cci-rochefort",
  "projet-republique",
  "maison-faubourg-rochefort",
  "cave-des-demoiselles",
  "grange-marsais",
  "maison-rochefort",
  "ecomiam-saintes",
  "villa-la-rochelle",
  "saint-georges-didonne-extension",
];

// Extra details & before/after images per project (by index)
export const PROJECT_DETAILS = {
  fr: [
    { surface: "380 m²", duration: "9 mois", year: "2019", client: "CCI Rochefort & Saintonge", longDesc: "Transformation d'un plateau de bureaux vieillissant en salles de cours modernes et modulables. Dépose complète des cloisons existantes, reprise des réseaux, création d'une acoustique adaptée à l'enseignement, mobilier sur mesure.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "210 m²", duration: "12 mois", year: "2020", client: "Privé", longDesc: "Rénovation complète d'une maison de ville de style rochefortais. Conservation des moulures et parquets d'origine, isolation intérieure performante, création d'une cuisine ouverte et d'une suite parentale à l'étage.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "130 m²", duration: "22 mois", year: "2022", client: "Privé", longDesc: "Rénovation complète d'une maison de faubourg typique de Rochefort. Dépose des revêtements vieillissants, isolation intérieure performante, reprise des réseaux, restauration des menuiseries bois, création d'une cuisine ouverte.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "95 m²", duration: "6 mois", year: "2021", client: "La Cave des Demoiselles", longDesc: "Création ex-nihilo d'une cave à vins en centre-ville de Rochefort. Refonte de la devanture, aménagement intérieur dédié à la dégustation, régulation hygrothermique des espaces de stockage.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "165 m²", duration: "18 mois", year: "2022", client: "Privé", longDesc: "Transformation d'une grange rurale en habitation principale. Restauration de la charpente ancienne, création de grandes baies vitrées, sol en béton ciré, mezzanine contemporaine.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "240 m²", duration: "14 mois", year: "2023", client: "Privé", longDesc: "Rénovation complète avec extension contemporaine à ossature bois. Redistribution des espaces, création d'une suite parentale dans l'extension, ouverture sur jardin via une baie de 6 mètres.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "180 m²", duration: "5 mois", year: "2023", client: "Ecomiam", longDesc: "Réaménagement complet d'un local commercial pour l'installation d'une enseigne Ecomiam. Respect du cahier des charges de la marque, création des chambres froides, habillage de la façade.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "320 m²", duration: "20 mois", year: "2024", client: "Privé", longDesc: "Rénovation haut de gamme d'une maison de maître rochelaise. Menuiseries sur mesure, parquet point de Hongrie, cuisine de chef, piscine intérieure, baies accordéon donnant sur le jardin.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "180 m²", duration: "30 mois", year: "2026", client: "Privé", longDesc: "Extension contemporaine et rénovation complète d'une maison balnéaire des années 70 à Saint-Georges-de-Didonne. L'extension, habillée d'un bardage en mélèze pré-grisaillé, dialogue franchement avec le ravalement blanc de la maison existante. Menuiseries aluminium noir, grandes baies coulissantes côté pinède, toiture-terrasse à acrotère acier, isolation biosourcée. Livraison fin 2025.", beforeUrl: "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/f8dfx1z0_20230623_105333.jpg", afterUrl: "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/i3ebtleh_20251104_155736.jpg" },
  ],
  en: [
    { surface: "380 sqm", duration: "9 months", year: "2019", client: "CCI Rochefort & Saintonge", longDesc: "Transformation of an ageing office floor into modern modular classrooms. Complete removal of existing partitions, network overhaul, acoustic fit for teaching, bespoke furniture.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "210 sqm", duration: "12 months", year: "2020", client: "Private", longDesc: "Full renovation of a Rochefort-style townhouse. Preservation of original mouldings and parquets, high-performance interior insulation, open kitchen and master suite upstairs.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "130 sqm", duration: "22 months", year: "2022", client: "Private", longDesc: "Full renovation of a typical Rochefort faubourg house. Removal of ageing finishes, high-performance interior insulation, full network upgrade, restoration of the wooden joinery, open kitchen.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "95 sqm", duration: "6 months", year: "2021", client: "La Cave des Demoiselles", longDesc: "Ground-up creation of a wine cellar in central Rochefort. Storefront redesign, tasting-focused interior, hygrothermal control of storage spaces.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "165 sqm", duration: "18 months", year: "2022", client: "Private", longDesc: "Conversion of a rural barn into a primary home. Restoration of the old roof frame, creation of large glass openings, polished concrete floor, contemporary mezzanine.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "240 sqm", duration: "14 months", year: "2023", client: "Private", longDesc: "Full renovation with a wooden-frame contemporary extension. Space redistribution, master suite in the extension, 6-meter glass opening onto the garden.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "180 sqm", duration: "5 months", year: "2023", client: "Ecomiam", longDesc: "Full retail redesign for an Ecomiam store. Brand-spec fit-out, cold rooms, facade treatment.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "320 sqm", duration: "20 months", year: "2024", client: "Private", longDesc: "High-end renovation of a La Rochelle master house. Bespoke joinery, Hungarian-point parquet, chef's kitchen, indoor pool, folding glass doors to the garden.", beforeUrl: "/api/uploads/placeholder-pending.svg", afterUrl: "/api/uploads/placeholder-pending.svg" },
    { surface: "180 sqm", duration: "30 months", year: "2026", client: "Private", longDesc: "Contemporary extension and full renovation of a 1970s seaside house in Saint-Georges-de-Didonne. The extension, clad in pre-greyed larch, dialogues frankly with the white-rendered facade of the existing house. Black aluminium joinery, large sliding glass doors towards the pinewood, steel-edged flat roof, bio-sourced insulation. Delivered late 2025.", beforeUrl: "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/f8dfx1z0_20230623_105333.jpg", afterUrl: "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/i3ebtleh_20251104_155736.jpg" },
  ],
};

// Logo served from the backend uploads directory. Stored as a relative URL so
// it stays reachable regardless of the domain the frontend is served from.
export const LOGO_URL = "/api/uploads/logo-echo-320.webp?v=2";

// Patrimoine — façade rénovée Rochefort (ancien site, belle rénovation terminée)
export const HERO_IMAGE = "/api/uploads/placeholder-pending.svg";

export const PROJECT_IMAGES = [
  "/api/uploads/placeholder-pending.svg",
  "/api/uploads/placeholder-pending.svg",
  "/api/uploads/placeholder-pending.svg",
  "/api/uploads/placeholder-pending.svg",
  "/api/uploads/placeholder-pending.svg",
  "/api/uploads/placeholder-pending.svg",
  "/api/uploads/placeholder-pending.svg",
  "/api/uploads/placeholder-pending.svg",
  "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/ajynhfoc_20251104_155853.jpg",
];

// Extra gallery images per project (used on detail pages) — ordered to match PROJECT_SLUGS
export const PROJECT_GALLERIES = [
  [
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
  ],
  [
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
  ],
  [
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
  ],
  [
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
  ],
  [
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
  ],
  [
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
  ],
  [
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
  ],
  [
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
    "/api/uploads/placeholder-pending.svg",
  ],
  [
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/ajynhfoc_20251104_155853.jpg",
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/i3ebtleh_20251104_155736.jpg",
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/t2bia29a_20251104_155816.jpg",
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/mtskqrx0_20251104_155726.jpg",
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/ae551nbt_20251104_154704.jpg",
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/f8dfx1z0_20230623_105333.jpg",
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/ddi5oz2w_20230623_105402.jpg",
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/t7tbsirc_20230623_105441.jpg",
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/dqoapi8d_20230623_105612.jpg",
    "https://customer-assets.emergentagent.com/job_echo-new-look/artifacts/ze43z02v_20230623_105630.jpg",
  ],
];
